module.exports = __webpack_public_path__ + "static/media/icon_summary.e9db2ff4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon_summary.svg
// module id = 1536
// module chunks = 0